import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare } from '@fortawesome/pro-light-svg-icons'

import {
  Button,
  Columns,
  Grid,
  LoadingModule,
  Tools,
} from '@domain-group/suit-theme'

import useAdCopies from '@hooks/useAdCopies'
import useCampaign from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'
import useOrderItem from '@hooks/useOrderItem'
import useOrderItems from '@hooks/useOrderItems'
import useSelector from '@hooks/useSelector'

import adCopyTypes from '@functions/adCopy'

import EntityActivity from '@components/EntityActivity'
import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'

import AdCopyItem from '../AdCopyItem'
import OrderItemDetailsModule from '../OrderItemDetailsModule'
import OwnerDetailsModule from '../OwnerDetailsModule'
import PageLayout from '../../../../components/PageLayout'

const PageContent = (props: { campaignId: number}) => {
  const { campaignId } = props

  const campaignPayload = useCampaign({ id: campaignId })

  const {
    agency,
    callbacks: {
      shareProjectModal,
    },
    campaign,
    loading: campaignLoading,
  } = campaignPayload

  const { services } = useSelector(reduxState => reduxState.entities)
  const copyWritingService = Object.values(services).find(service => service.short_name === 'adcopy')

  const orderItemsPayload = useOrderItems({
    filters: { campaign_id: campaignId, service_id: copyWritingService?.id },
    requestOptions: {
      include_order_item_campaign_id: true,
      include_order_item_due_date: true,
    },
    performHttpRequests: !!campaignId,
  })
  const { filteredOrderItems, loading: orderItemsLoading } = orderItemsPayload

  // order items are sorted desc by id by default. selects most recent order item
  const selectedOrderItem = filteredOrderItems[0] || {}

  const adCopiesPayload = useAdCopies({
    filters: { order_item_id: selectedOrderItem?.id },
    performHttpRequests: !!selectedOrderItem?.id,
  })
  const { filteredAdCopies, loading: adCopiesLoading } = adCopiesPayload

  const orderItemPayload = useOrderItem({ id: selectedOrderItem.id })
  const { callbacks: { manageProviderOrderItemStatusModal } } = orderItemPayload

  const { provider } = useCurrentUser()

  return (
    <PageLayout entityPayload={campaignPayload} activeTabBarItemKey="copywriting">
      <Columns.Main>
        <NotificationBannerLocation locationKey="provider.campaign.copywriting.banner" />

        <LoadingModule loading={orderItemsLoading || adCopiesLoading} times={3} />

        {!adCopiesLoading && !!selectedOrderItem.id && adCopyTypes.map((adCopyType) => {
          const { key, title } = adCopyType
          const adCopy = filteredAdCopies.find(a => a.copy_type === key) || {
            order_item_id: selectedOrderItem.id,
            copy_type: key,
          }

          return <AdCopyItem adCopy={adCopy} campaignId={campaignId} key={key} title={title} />
        })}

        {!!selectedOrderItem.id && <EntityActivity subjectId={selectedOrderItem.id} subjectType="OrderItem" />}
      </Columns.Main>

      <Columns.Sidebar>
        <NotificationModuleLocation locationKey="provider.campaign.copywriting.sidebar" />

        <Tools>
          {/*
           // @ts-expect-error TS2322 */}
          <Grid gridRowGap="medium">
            <Button
              buttonStyle="secondaryUtility"
              icon={<FontAwesomeIcon icon={faShare} />}
              onClick={() => manageProviderOrderItemStatusModal()}
              size="medium"
            >
              Manage Order Item
            </Button>

            <Button
              buttonStyle="secondaryUtility"
              icon={<FontAwesomeIcon icon={faShare} />}
              // @ts-expect-error TS2345
              onClick={() => shareProjectModal(provider, selectedOrderItem)}
              size="medium"
            >
              Share Copy
            </Button>
          </Grid>
        </Tools>

        <OrderItemDetailsModule orderItem={selectedOrderItem} loading={orderItemsLoading} />

        {!campaignLoading && (
          <OwnerDetailsModule agency={agency} campaign={campaign} loading={campaignLoading} />
        )}
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
